import type { FacilityEncounter } from '@seen/core/models/encounters/facility-encounter'
import { ExtendedLocation } from '@seen/core/models/location'
import { isOfType } from '@seen/core/utils'
import type { JSX } from 'react'
import { ParticipantName } from '#src/components/ParticipantName.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

export function FacilityEncounterItem({
  encounter,
}: {
  encounter: FacilityEncounter
}): JSX.Element {
  const { data: location } = useRead(ExtendedLocation, encounter.location)
  return (
    <TimelineTextEntry
      actor={encounter.practitioner ?? 'Unknown'}
      time={encounter.lastUpdatedDate}
      action={
        <>
          {encounter.status === 'in-progress' &&
            isOfType(encounter.subject, 'Patient') && (
              <>
                checked <ParticipantName participant={encounter.subject} /> in
                at {location?.name}
              </>
            )}
          {encounter.status !== 'in-progress' &&
            isOfType(encounter.subject, 'Patient') && (
              <>
                checked <ParticipantName participant={encounter.subject} /> out
                of {location?.name}
              </>
            )}
        </>
      }
      reference={encounter.reference}
      originTask={encounter.queuedEditsOriginTask}
    />
  )
}
